<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo"
    >
      <!--<el-menu-item index="1" @click="toNewRouter('finance-over-view')" v-if="permissionCodes.indexOf('013001000') !== -1">-->
      <!--<i class="el-icon-damai-shujulaiyuan" style="font-size: 16px;"></i>-->
      <!--<span slot="title">概览</span>-->
      <!--</el-menu-item>-->

      <el-menu-item
        index="2"
        @click="toNewRouter('activity-manage')"
        v-if="permissionCodes.indexOf('019001000') !== -1"
      >
        <i class="el-icon-damai-huodong1" style="font-size: 24px"></i>
        <span slot="title">活动管理</span>
      </el-menu-item>

      <el-menu-item
        index="3"
        @click="toNewRouter('registration-record')"
        v-if="permissionCodes.indexOf('019002000') !== -1"
      >
        <i class="el-icon-damai-yaoqing"></i>
        <span slot="title">报名人员</span>
      </el-menu-item>

      <el-menu-item
        index="4"
        @click="toNewRouter('event-statistics')"
        v-if="permissionCodes.indexOf('019003000') !== -1"
      >
        <i class="el-icon-damai-sign" style="font-size: 20px"></i>
        <span slot="title">报名统计</span>
      </el-menu-item>

      <el-menu-item
        index="5"
        @click="toNewRouter('activity-consumption-record')"
        v-if="permissionCodes.indexOf('019004000') !== -1"
      >
        <i class="el-icon-damai-pay"></i>
        <span slot="title">缴费记录</span>
      </el-menu-item>

      <el-menu-item index="6" @click="toNewRouter('activity-log')" v-if="permissionCodes.indexOf('019005000') !== -1">
        <i class="el-icon-damai-ic_caozuorizhi"></i>
        <span slot="title">操作日志</span>
      </el-menu-item>

    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  2: ["activity-manage", "activity-add", "activity-modify"],
  3: ["registration-record"],
  4: "event-statistics",
  5: ["activity-consumption-record"],
  6: ["activity-log"],
});

export default {
  name: "phone-service-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  mounted() {
    bus.vue.$on("changeIsCollapse", (data) => {
      this.isCollapse = data;
    });
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/Activity/ActivityNav.vue